var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'actions',
    'align-items-center',
    _vm.small ? _vm.sm : _vm.md,
    _vm.forTabs ? 'for-tabs' : '' ]},[_c('button',{staticClass:"action mx-1",on:{"click":_vm.prev}},[_c('fa',{attrs:{"icon":['fa', _vm.$activeLang == 'ar' ? 'chevron-right' : 'chevron-left']}})],1),_c('button',{staticClass:"action mx-1",on:{"click":_vm.next}},[_c('fa',{attrs:{"icon":['fa', _vm.$activeLang == 'ar' ? 'chevron-left' : 'chevron-right']}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }